module.exports = __webpack_public_path__ + "img/b6-2.45ef1fe.png";